export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7a2674447e4f4b99899d1274c088d789.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-8 max-w-5xl mx-auto">
        <h1 className="mb-6">
          <div className="text-7xl font-extrabold text-white tracking-wide mb-2">
            MODERN iOS
          </div>
          <div className="text-6xl font-serif italic text-white/85">
            Applications
          </div>
        </h1>
        
        <p className="text-xl text-white/70 max-w-2xl mx-auto leading-relaxed">
          Expert team crafting premium applications<br />
          for enhanced mobile experience and security
        </p>
      </div>
    </section>
  );
}
